import { LOCAL_STORAGE_KEYS } from '@/utils/constants'
import { apiHeaders } from '../../utils/utils'
import axiosWrapper from '../helpers/api'
import { ERequestUrl, EMethods } from '../helpers/requests'

export const getAddress = () =>
  axiosWrapper({
    method: EMethods.get,
    url: ERequestUrl.address,
    headers: apiHeaders(
      localStorage.getItem(LOCAL_STORAGE_KEYS.CONNEXION_TYPE)
    ),
  })

export const postAddress = (data) =>
  axiosWrapper({
    method: EMethods.post,
    url: ERequestUrl.address,
    data: data,
    headers: apiHeaders(
      localStorage.getItem(LOCAL_STORAGE_KEYS.CONNEXION_TYPE)
    ),
  })

export const putAddress = (data, id) =>
  axiosWrapper({
    method: EMethods.put,
    url: ERequestUrl.address,
    data: data,
    uid: id.toString(),
    headers: apiHeaders(
      localStorage.getItem(LOCAL_STORAGE_KEYS.CONNEXION_TYPE)
    ),
  })

export const patchAddress = (id) =>
  axiosWrapper({
    method: EMethods.patch,
    url: ERequestUrl.address,
    uid: `${id.toString()}/default`,
    headers: apiHeaders(
      localStorage.getItem(LOCAL_STORAGE_KEYS.CONNEXION_TYPE)
    ),
  })
